import React, { useEffect, useMemo, useState } from 'react'
import { isNull, isUndefined } from 'lodash'
import { Link } from 'react-router-dom'
import useStoreSelector from 'utils/hooks/useStoreSelector'
import { CREATED } from 'pages/Scenario/constants'
import { getInstancesList } from 'src/App/actions'
import { updateInstanceRow } from 'pages/Scenario/utils/state'
import { synapse } from 'services/state'
import cn from 'classnames'

const TitleColumnFramework = (param) => {
  const {
    value,
    data: { scenarioInstance: scenId, id }
  } = param
  const buffer = useStoreSelector('scenario', (store) => store.buffer)
  const MAX_CHARS = 30
  const [scenInstance, setScenInstance] = useState(scenId)

  const createTitle = (columnWidth) => {
    const width = columnWidth || param.column?.getActualWidth()
    const charAllowed = parseInt((width - 60) / 8)
    return !isUndefined(value) &&
      value.length > MAX_CHARS &&
      charAllowed < value.length
      ? `${value.substring(0, charAllowed)}...`
      : value
  }

  const [title, setTitle] = useState(createTitle())

  useEffect(() => {
    // OLD CODE
    // if (!isUndefined(buffer[id])) {
    //   const { status, scenarioInstance, total, progress } = buffer[id]

    //   const addScenarioInstance = // if a new scenario
    //     status === CREATED && total === 0 && progress === 0

    //   if (addScenarioInstance) {
    //     const scenarios = scenarioStore.get().originalData ?? []
    //     const index = scenarios.findIndex((el) => el.id === id)
    //     if (index >= 0) {
    //       const scenario = scenarios[index]
    //       // avoid loop
    //       if (scenario.scenarioInstance !== scenInstance) {
    //         updateInstanceRow(id, scenarioInstance)
    //         getInstancesList()
    //         setScenInstance(scenarioInstance)
    //       } else {
    //         // remove duplicated row, row without link
    //         const toRemove = param.api.getRenderedNodes()[0]
    //         const transaction = { remove: [toRemove.data] }
    //         param.api.applyTransaction(transaction)
    //       }
    //     }
    //   }
    // }
    if (!isUndefined(buffer[id])) {
      // In products 1.0 scenarioInstance does not exist, so we use scenarioId in this case.
      const { status, scenarioInstance, scenarioId } = buffer[id]
      const addScenarioInstance = status === CREATED

      if (addScenarioInstance) {
        setScenInstance(scenarioInstance ?? scenarioId)
        const toUpdated =
          param.api
            .getRenderedNodes()
            .find(
              ({ data }) =>
                data.scenarioInstance === scenarioInstance ||
                data.scenarioId === scenarioId
            ) || param.api.getRenderedNodes()[0]
        updateInstanceRow(id, scenarioInstance ?? scenarioId, toUpdated)
        getInstancesList()
      }
    }
  }, [buffer[id]])

  useEffect(() => {
    const unsubscribe = synapse.subscribe(
      'columnResized',
      ({ columnWidth }) => {
        setTitle(createTitle(columnWidth))
      }
    )
    return () => {
      unsubscribe()
    }
  }, [])

  if (isUndefined(scenInstance) || isNull(scenInstance)) {
    return value
  }

  // const warning = id === 'fc0162d2-4abc-44b6-b709-63cb53f0a432'
  // console.log(param.data)
  return (
    <div className='title-column'>
      <Link to={`/instances/${scenInstance}/workingtables`}>{title}</Link>
    </div>
  )
}

export default TitleColumnFramework

// setScenInstance(scenarioInstance ?? scenarioId)

// const toUpdated = param.api.getRenderedNodes()[0]
// updateInstanceRow(id, scenarioInstance ?? scenarioId, toUpdated)
